import { createFileRoute } from "@tanstack/react-router"

import { TabletWarehouseReceivingLayout } from "@/screens/Tablet/WarehouseReceiving/TabletWarehouseReceivingLayout"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/_layout")({
  component: TabletWarehouseReceivingLayout,
})
